// extracted by mini-css-extract-plugin
export default {"mainBlock":"eeba1b703ddd4114","highlighted":"_9e1da8ea7fced114"};